// @flow

import * as React from "react";
import { ReactForm, ReactFormField } from "@adrenalin/react-form";
import SearchSelect from "@components/atoms/SearchSelect";
import { postcode } from "@constants/Validators";

type PropsType = {
    action: ?string,
    hiddenInputs: ?any,
};

const PostRegistrationForm = (props: PropsType): React.Node => {
    console.log(props);
    return (
        <ReactForm
            pageSubmit
            method="POST"
            action={props.action || ""}
            validators={[postcode]}
        >
            <ReactFormField
                fieldComponent={SearchSelect}
                type="select"
                name="speciality"
                required={true}
                errorMessages={{
                    required: "Please select a speciality.",
                }}
                label="Speciality<p>To receive personalised suggestions on news and articles</p>"
                placeholder="Search and select a speciality"
                defaultValue="" // always pass defaultValue (empty if no preset)
            >
                {props.fields.speciality.map((value, _): HTMLOptionElement => {
                    return (
                        <option value={value.value} key={value.value}>
                            {value.label}
                        </option>
                    );
                })}
            </ReactFormField>

            <ReactFormField
                type="number"
                name="field_postcode[0][target_id]"
                required={true}
                validators={["vaxiplace-postcode"]}
                errorMessages={{
                    required: "Please enter a postcode.",
                }}
                label="Postcode<p>Your postcode will allow us to show you up-to-date vaccination stock information for your state</p>"
            />

            {/* <ReactFormField
                type="checkbox"
                label="I consent to receive educational and promotional updates on upcoming meetings, innovations and products from Sanofi-Aventis Australia Pty Ltd and its affiliates. I understand that I can opt out of receiving these communications at any time."
                name="subscribe-marketing"
            /> */}

            {/* <ReactFormField
                type="checkbox"
                label="I consent to receive educational and promotional updates on upcoming meetings, innovations and products from Sanofi-Aventis Australia Pty Ltd and its affiliates. I understand that I can opt out of receiving these communications at any time. "
                name="consent"
                value="1"
            /> */}

            <button type="submit" className="button button--wide">
                Complete registration
            </button>

            {props.hiddenInputs || null}
        </ReactForm>
    );
};

export default PostRegistrationForm;
